import { useToast } from 'native-base';
import { useEffect } from 'react';
import { Heading, Layout, Spinner, Text } from '../../../../components/core/index';
import { getRoute, useNavigate } from '../../../../routes';
import { getStylesheet } from '../../../../styles';
import { useSaveSurveyAnswersLazy } from '../hooks/useSaveSurvey';

export const SurveyFinishPageContent = (): JSX.Element => {
  const navigate = useNavigate();
  const toast = useToast();

  const [saveAnswers] = useSaveSurveyAnswersLazy({
    onCompleted: () => {
      setTimeout(() => {
        navigate(getRoute('surveyResults', {}));
      }, 3000);
    },
    onError: () => {
      toast.show({
        description: 'Survey could not be saved.',
        duration: 3000,
      });
    },
  });

  useEffect(() => {
    void saveAnswers();
  }, []);

  return (
    <Layout.Slide {...styles.wrapper} testID="survey-finish-page-content">
      <Layout.VStack {...styles.content} space={2}>
        <Heading.h2 textAlign="center">
          Saving your answers & preparing your recommendations...
        </Heading.h2>
        <Text.para>Please do not leave this page.</Text.para>
      </Layout.VStack>
      <Spinner accessibilityLabel="Loading Survey Results" />
    </Layout.Slide>
  );
};

const styles = getStylesheet({
  wrapper: {
    alignItems: 'center',
    flex: 1,
  },

  content: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
    marginBottom: '30%',
  },
});
